import {
  BookOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  FolderOpenOutlined,
  RiseOutlined,
  SettingOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useLocation } from '@umijs/max';
import { theme } from 'antd';
import React from 'react';

import { getActiveTopNavKey, TOP_NAV_ITEMS } from '@/navigation/topNav';
import { navigateWithBrowserGestureSupport } from '@/utils/linkNavigation';
import styles from './TopNavBanner.module.less';

const ICON_MAP: Record<string, React.ReactNode> = {
  book: <BookOutlined />,
  customerService: <CustomerServiceOutlined />,
  dashboard: <DashboardOutlined />,
  folderOpen: <FolderOpenOutlined />,
  rise: <RiseOutlined />,
  setting: <SettingOutlined />,
  team: <TeamOutlined />,
};

const TopNavBanner: React.FC = () => {
  const location = useLocation();
  const activeKey = getActiveTopNavKey(location.pathname);
  const { token } = theme.useToken();

  return (
    <nav className={styles.banner}>
      {TOP_NAV_ITEMS.map((item) => {
        const isActive = activeKey === item.key;
        return (
          <a
            key={item.key}
            href={item.path}
            aria-current={isActive ? 'page' : undefined}
            onClick={(event) => {
              navigateWithBrowserGestureSupport(event, item.path);
            }}
            className={`${styles.item}${isActive ? ` ${styles.active}` : ''}`}
            style={{
              color: isActive ? token.colorPrimary : undefined,
              fontWeight: isActive ? 500 : undefined,
            }}
          >
            {ICON_MAP[item.icon] && (
              <span className={styles.icon}>{ICON_MAP[item.icon]}</span>
            )}
            <span className={styles.label}>{item.label}</span>
          </a>
        );
      })}
    </nav>
  );
};

export default TopNavBanner;
